import { FC } from 'react';
import './Loader.scss';

const Loader: FC<{ size?: 's' | 'm' | 'l'; fullScreen?: boolean }> = ({ size = 'm', fullScreen = false }) => {
    return (
        <div className={`overlay ${fullScreen ? 'full' : ''}`}>
            <div className={`spin center ${size}`}>
                <div className="spin-blade"></div>
                <div className="spin-blade"></div>
                <div className="spin-blade"></div>
                <div className="spin-blade"></div>
                <div className="spin-blade"></div>
                <div className="spin-blade"></div>
                <div className="spin-blade"></div>
                <div className="spin-blade"></div>
                <div className="spin-blade"></div>
                <div className="spin-blade"></div>
                <div className="spin-blade"></div>
                <div className="spin-blade"></div>
            </div>
        </div>
    );
};

export default Loader;
